{
  "name": "bwm-frontend",
  "version": "5.5.4",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start-bwm": "npm run precheck && ng serve --configuration bwm --host 0.0.0.0",
    "start-liberro": "npm run precheck && ng serve --configuration liberro",
    "build-dev": "ng build --configuration development --output-hashing bundles",
    "build-bwm": "ng build --configuration bwm --output-hashing bundles",
    "build-liberro": "ng build --configuration liberro --output-hashing bundles",
    "build": "ng build",
    "build-capacitor-bwm": "ng build --configuration bwm && npx cap sync && node capacitor-update.js",
    "build-capacitor-liberro": "ng build --configuration liberro && npx cap sync && node capacitor-update.js",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "capacitor-sync": "ng build && npx cap sync",
    "test:e2e": "npx cypress run --spec {1}",
    "lint": "ng lint",
    "precheck": "node scripts/app-mode-translate-keys.script.js"
  },
  "private": true,
  "dependencies": {
    "@angular-architects/ngrx-toolkit": "21.0.1",
    "@angular/animations": "21.2.19",
    "@angular/common": "21.2.19",
    "@angular/compiler": "21.2.19",
    "@angular/core": "21.2.19",
    "@angular/forms": "21.2.19",
    "@angular/platform-browser": "21.2.19",
    "@angular/router": "21.2.19",
    "@ant-design/icons-angular": "21.0.0",
    "@capacitor/android": "8.4.2",
    "@capacitor/app": "8.1.1",
    "@capacitor/browser": "8.0.4",
    "@capacitor/core": "8.4.2",
    "@capacitor/file-transfer": "2.0.4",
    "@capacitor/file-viewer": "2.0.1",
    "@capacitor/filesystem": "8.1.2",
    "@capacitor/ios": "8.4.2",
    "@capacitor/keyboard": "8.0.5",
    "@capacitor/network": "8.0.1",
    "@capacitor/preferences": "8.0.1",
    "@capacitor/privacy-screen": "2.0.1",
    "@capacitor/push-notifications": "8.1.2",
    "@capacitor/screen-orientation": "8.0.1",
    "@capacitor/share": "8.0.1",
    "@capacitor/status-bar": "8.0.3",
    "@capgo/capacitor-inappbrowser": "8.14.0",
    "@capgo/capacitor-native-biometric": "8.6.7",
    "@capgo/capacitor-navigation-bar": "8.2.6",
    "@ng-idle/core": "16.0.0",
    "@ngrx/signals": "21.1.1",
    "@ngx-translate/core": "18.0.0",
    "@ngx-translate/http-loader": "18.0.0",
    "@sentry/angular": "10.67.0",
    "angular-svg-icon": "19.1.1",
    "apexcharts": "5.15.2",
    "big.js": "7.0.1",
    "bootstrap": "5.3.8",
    "capacitor-plugin-app-tracking-transparency": "2.0.5",
    "capacitor-plugin-safe-area": "5.0.1",
    "cropperjs": "1.6.2",
    "dayjs": "1.11.21",
    "decimal.js": "10.4.3",
    "file-saver": "2.0.5",
    "i18n-iso-countries": "7.12.0",
    "ibantools": "4.3.3",
    "lodash.isequal": "4.5.0",
    "ng-apexcharts": "2.4.0",
    "ng-zorro-antd": "21.3.3",
    "ngx-pagination": "6.0.3",
    "ngx-toastr": "20.0.5",
    "posthog-js": "1.407.5",
    "qrcode": "1.5.4",
    "quill": "2.0.2",
    "rxjs": "7.8.2",
    "swiper": "12.2.0",
    "tippy.js": "6.3.7",
    "tslib": "2.8.1",
    "vanilla-cookieconsent": "3.1.0",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular/build": "21.2.20",
    "@angular/cli": "21.2.20",
    "@angular/compiler-cli": "21.2.19",
    "@capacitor/cli": "8.4.2",
    "@ngx-env/builder": "21.0.1",
    "@types/big.js": "7.0.0",
    "@types/file-saver": "2.0.7",
    "@types/jasmine": "~3.10.0",
    "@types/lodash.isequal": "4.5.8",
    "@types/node": "22.20.1",
    "@types/qrcode": "1.5.6",
    "angular-eslint": "21.4.0",
    "autoprefixer": "10.4.5",
    "cypress": "14.5.2",
    "eslint": "9.30.1",
    "jasmine-core": "~4.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "less": "4.2.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "8.63.0",
    "yargs": "18.0.0"
  },
  "allowScripts": {
    "esbuild@0.28.1": true,
    "cypress@14.5.2": true,
    "@parcel/watcher@2.6.0": true,
    "fsevents@2.3.3": true,
    "lmdb@3.5.1": true,
    "msgpackr-extract@3.0.4": true,
    "core-js": false
  }
}
